(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wm_seletor_necessidades"] && !Shopify.designMode) return;
  try {
    
  // ========== FUNÇÃO PRINCIPAL ==========
  function initNeedsSelector(root) {
    const sectionId = root.dataset.needsSelectorSection;
    const needItems = root.querySelectorAll('[data-need-item]');
    let swiperInstance = null;
    let swiperLoading = false;

    // ---------- ANIMAÇÃO DE ENTRADA ----------
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -30px 0px' }
    );

    needItems.forEach((item) => {
      revealObserver.observe(item);

      // ---------- LÓGICA DE SELEÇÃO ----------
      item.addEventListener('click', function (e) {
        if (this.tagName === 'A') return;

        e.preventDefault();

        needItems.forEach((el) => {
          if (el.tagName !== 'A') el.classList.remove('is-active');
        });

        this.classList.add('is-active');

        const value = this.dataset.needValue || this.querySelector('.needs-selector__label')?.innerText?.trim() || '';
        document.dispatchEvent(
          new CustomEvent('needs-selector:change', {
            detail: { value, element: this },
          })
        );
      });

      item.addEventListener('keydown', function (e) {
        if (this.tagName === 'A') return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });

    // ---------- CARROSSEL (Swiper) no mobile ----------
    const carouselEl = root.querySelector('.needs-selector__carousel');
    const prevBtn = root.querySelector('.needs-selector__button.prev');
    const nextBtn = root.querySelector('.needs-selector__button.next');

    function loadSwiperAndInit() {
      if (swiperLoading) return;
      
      if (typeof Swiper === 'undefined') {
        swiperLoading = true;
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.onload = () => {
          swiperLoading = false;
          initSwiper();
        };
        script.onerror = () => {
          swiperLoading = false;
        };
        document.head.appendChild(script);

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        document.head.appendChild(link);
      } else {
        initSwiper();
      }
    }

    function initSwiper() {
      if (!carouselEl) return;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
      const prevId = prevBtn?.id;
      const nextId = nextBtn?.id;
      if (!prevId || !nextId) return;

      // Swiper com slidesPerView: 2 para mostrar exatamente 2 cards
      swiperInstance = new Swiper(carouselEl, {
        slidesPerView: 2,
        spaceBetween: 16,
        navigation: {
          nextEl: `#${nextId}`,
          prevEl: `#${prevId}`,
        },
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          600: {
            slidesPerView: 2.5,
            spaceBetween: 18,
          },
        },
        simulateTouch: true,
        touchRatio: 1,
      });
    }

    function checkAndInitSwiper() {
      if (window.innerWidth <= 768) {
        if (!swiperInstance) {
          loadSwiperAndInit();
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    }

    // Inicializa imediatamente se for mobile
    checkAndInitSwiper();

    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        checkAndInitSwiper();
      }, 200);
    };
    window.addEventListener('resize', handleResize);

    return function cleanup() {
      window.removeEventListener('resize', handleResize);
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
      revealObserver.disconnect();
    };
  }

  // ========== INICIALIZAÇÃO GLOBAL ==========
  const cleanups = new Map();

  function initAllSelectors() {
    document.querySelectorAll('[data-needs-selector-section]').forEach((root) => {
      const sectionId = root.dataset.needsSelectorSection;
      if (cleanups.has(sectionId)) {
        cleanups.get(sectionId)();
        cleanups.delete(sectionId);
      }
      const cleanup = initNeedsSelector(root);
      cleanups.set(sectionId, cleanup);
    });
  }

  // Inicializa no DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSelectors);
  } else {
    initAllSelectors();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-needs-selector-section]');
    if (root) {
      const sectionId = root.dataset.needsSelectorSection;
      if (cleanups.has(sectionId)) {
        cleanups.get(sectionId)();
        cleanups.delete(sectionId);
      }
      const cleanup = initNeedsSelector(root);
      cleanups.set(sectionId, cleanup);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-needs-selector-section]');
    if (root) {
      const sectionId = root.dataset.needsSelectorSection;
      if (cleanups.has(sectionId)) {
        cleanups.get(sectionId)();
        cleanups.delete(sectionId);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
